import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { ApplicantDeclarationView } from "./view";
import { useNavigate } from "react-router-dom";
import "./style.css";
import showToast from "../../services/toast";
import LocalStorageService from "../../services/localStorage";
import { navigateBack, navigateNext, stepProgress, } from "../../dataBase/stepProgress";
import { hasPermission } from "../../services/getNavigationPages";
import { STEP_APPLICANTDECLARATION } from "../../const/catalog";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var ApplicantDeclarationPage = function () {
    var STEP = STEP_APPLICANTDECLARATION;
    var navigate = useNavigate();
    var _a = React.useState("0.00"), prima = _a[0], setPrima = _a[1];
    var _b = useState(false), showInfo = _b[0], setShowInfo = _b[1];
    var _c = React.useState([]), steps = _c[0], setSteps = _c[1];
    var _d = useState([]), filters = _d[0], setFilters = _d[1];
    var _e = React.useState([]), breadCrumbs = _e[0], setBreadCrumbs = _e[1];
    var _f = useState(true), showNextDisabled = _f[0], setShowNextDisabled = _f[1];
    var _g = useState(false), loading = _g[0], setLoading = _g[1];
    var _h = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _h[0], setSeeToast = _h[1];
    var permissions = {
        create: hasPermission("applican-declaration-view"),
    };
    var storageKey = "afy-steps";
    var localStorageService = new LocalStorageService(storageKey);
    useEffect(function () {
        setBreadCrumbs(stepProgress(STEP, true));
        setSteps(stepProgress(STEP));
        setFilters([
            {
                name: "Producto",
                label: "N/A",
                type: "label",
            },
            {
                name: "Plan",
                label: "N/A",
                type: "label",
                showChangeButton: false,
            },
        ]);
    }, []);
    var handleClickPrevious = function (e) {
        navigateBack(STEP, navigate);
    };
    var handleClickNext = function (e) {
        if (e && e.constructor.name === "SyntheticBaseEvent") {
            navigateNext(STEP, navigate);
            return;
        }
        setLoading(true);
        try {
            setShowNextDisabled(false);
            console.log("---->", e);
            // localStorageService.setStepStored({
            //   id: "",
            //   name: "",
            //   step: Steps.applicantDeclaration,
            //   completed: true,
            //   applicantDeclaration: e,
            // });
            setSeeToast({
                show: true,
                message: "Los datos han sido guardados",
                type: typeAlert.success,
            });
            setLoading(false);
        }
        catch (error) {
            console.log(error);
            setLoading(false);
            setShowNextDisabled(true);
            setSeeToast({
                show: true,
                message: "Error al guardar",
                type: typeAlert.error,
            });
        }
    };
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loading, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: "Cargando" }), _jsx(ApplicantDeclarationView, { title: "Resumen de asegurabilidad del solicitante", hideFilter: false, breadcrumbs: breadCrumbs, steps: steps, stepProgress: steps, previousLabel: "Anterior", nextLabel: "Nueva cotización", nextDisabled: showNextDisabled, showInfo: showInfo, onClickNext: handleClickNext, onClickPrevious: handleClickPrevious, filters: filters, resumeDescription: "Valor estimado", resumeValue: "DOP $ ".concat(prima) })] }));
};
